import { useState } from "react";
import { Dialog, IconButton } from "@educaplay/core";
import classes from "./bankImage.module.scss";
import { Search } from "@educaplay/core/Icons/Search";
import clsx from "clsx";
import BankText from "../BankText";

export function BankImage(props) {
  const { text, source, hideText, dashed } = props;
  const [open, setOpen] = useState(false);
  
  const clickImage = (e) => {
    e.stopPropagation();
    setOpen(true);
  };
  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)} variant="lightbox">
        <img src={source} alt="" />
      </Dialog>

      <div
        className={clsx(
          classes.imageContainer,
          dashed && classes.dashed
        )}
      >
        <div className={classes.layout}>
          <div className={classes.imageArea}>
            <img src={source} alt="" onClick={clickImage} />
            <IconButton
              icon={<Search />}
              onClick={clickImage}
              className={classes.expand}
            />
          </div>

          {text && !hideText && (
            <div className={classes.textArea}>
              <BankText text={text} dashed={dashed} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default BankImage;
